module.exports = __webpack_public_path__ + "static/media/qualitas-heart-percent.fba4ffe4.svg";